import { createRouter, createWebHashHistory } from "vue-router";
import unit from "./unit";
import menu from "./menu";
import appData from "../app";
import { useMain } from "@/store/index";

const routes = [
  {
    path: "/",
    name: "home",
    //使用import可以路由懒加载，如果不使用，太多组件一起加载会造成白屏
    component: () => import("@/page/newMain.vue"),
    children: [
      ...unit,
      ...menu,
      {
        path: "/users",
        name: "Users",
        component: () => import("@/page/users/index.vue"),
      },
      {
        path: "/exterior/url",
        name: "ExteriorUrl",
        component: () => import("@/page/openExteriorUrl.vue"),
      },
      {
        path: "/merchant/mode",
        name: "MerchantMode",
        component: () => import("@/page/merchant/index.vue"),
      },
      {
        path: "/classify",
        name: "Classify",
        component: () => import("@/page/classify/Classify.vue"),
      },
      {
        path: "/shoppe/checkList",
        name: "ShoppeCheckList",
        component: () => import("@/page/check/ShoppeCheckList.vue"),
      },
      {
        path: "/shoppe/type",
        name: "ShoppeType",
        component: () => import("@/page/shopType/index.vue"),
      },
      {
        path: "/batch/user",
        name: "BatchUser",
        component: () => import("@/page/userBatch/index.vue"),
      },
      { 
        path: "/monitor",
        name: "Monitor",
        component: () => import("@/page/monitor/index.vue"),
      },
      {
        path: "/payee/wx/merchant",
        name: "WXMerchant",
        component: () => import("@/page/payee/WXMerchant.vue"),
      },
      {
        path: "/:catchAll(.*)",
        name: "iframe",
        component: () => import("@/page/iframe.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/page/login.vue"),
  },
  {
    path: "/m-login",
    name: "MLogin",
    component: () => import("@/page/mLogin.vue"),
  },
  {
    path: "/order/print",
    name: "OrderPrint",
    component: () => import("@/page/order/OrderPrint.vue"),
  },
  {
    path: "/stat",
    name: "Stat",
    component: () => import("@/page/stat.vue"),
  },
  {
    path: "/finance/print",
    name: "FinancePrint",
    component: () => import("@/page/finance/FinancePrint.vue"),
  },
  {
    path: "/change-password",
    name: "changePassword",
    component: () => import("@/page/changePassword.vue"),
  },
  {
    path: "/settlementDoc/print",
    name: "settlementDocprint",
    component: () => import("@/page/finance/settlementDocprint.vue"),
  },
  {
    path: "/wecom/index",
    name: "wecomIndex",
    component: () => import("@/page/wecom/index.vue"),
  },
];
// 路由
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const store = useMain();

  const token = localStorage.getItem("token") || "";
  const roleInfo = localStorage.getItem("roleInfo") || "";
  const path = store.deviceType === "mobile" ? "/m-login" : "/login";
  if (store.deviceType === "mobile") {
    if (to.fullPath === "/login") {
      next(path);
      return;
    }
  }
  if (store.deviceType === "web") {
    if (to.fullPath === "/m-login") {
      next(path);
      return;
    }
  }

  if (to.fullPath === "/login" || to.fullPath === "/m-login") {
    next();
    return;
  }
  console.log('to.fullPath',to.fullPath);
  if (!token || !roleInfo) {
    if(to.fullPath.includes('wecom/index')){
      //企微扫码无需鉴权
      next();
    }else{
      next({ path });
    }
  } else {
    next();
  }
});

export default router;
